export class ForbiddenError extends Error {
  status: number;
  constructor() {
    super('Forbidden');
    this.status = 403;
    this.name = 'ForbiddenError';
    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}
